import MasterService from "./MasterService";

const InsurerService = {
    ...MasterService,

    getInsurerListData(params: object) {
        return this.post('/Insurer/getInsurerList', params)
    },

    editInsurer(params: object) {
        return this.post('/Insurer/editInsurer', params)
    },

    addInsurer(params: object) {
        return this.post('/Insurer/addInsurer', params)
    },

    updateInsurerStatus(params: object) {
        return this.post('/Insurer/updateInsurerStatus', params)
    }
}

export default InsurerService;